import { DialogConfirmDelete, LoadingLayout } from 'components';
import { useScrollToTop } from 'hooks';
import { usePageTitle } from 'libs/navigation';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { DialogChangeStatusFeature } from '../feature';
import { useOperation } from '../hooks';
import { OperationProvider } from '../providers/OperationProvider';
import { OperationView } from '../views';

export const OperationContainer = () => {
  const {
    operation,
    title,
    breadcrumbsTitles,
    brokerTimezoneOffset,
    initialValues,
    loading,
    notFound,
    submitLoading,
    isOpenDialogChangeStatus,
    isOpenDialogConfirmDelete,
    loadingDelete,
    onCloseDialogChangeStatus,
    onSuccessChangeStatus,
    onOpenDialogChangeStatus,
    onSubmit,
    onEnableEdit,
    onDisableEdit,
    onOpenDialogConfirmDelete,
    onCloseDialogConfirmDelete,
    onDelete,
  } = useOperation();

  usePageTitle(title);

  useScrollToTop([]);

  if (notFound) {
    return <ErrorFallback />;
  }

  if (loading || !operation) {
    return <LoadingLayout />;
  }

  return (
    <OperationProvider
      operation={operation}
      onChangeStatus={onOpenDialogChangeStatus}
      onDelete={onOpenDialogConfirmDelete}
      onDisableEdit={onDisableEdit}
      onEnableEdit={onEnableEdit}
    >
      <OperationView
        breadcrumbsTitles={breadcrumbsTitles}
        brokerTimezoneOffset={brokerTimezoneOffset}
        initialValues={initialValues}
        submitLoading={submitLoading}
        title={title}
        onSubmit={onSubmit}
      />
      <DialogChangeStatusFeature
        isOpen={isOpenDialogChangeStatus}
        onClose={onCloseDialogChangeStatus}
        onSuccess={onSuccessChangeStatus}
      />
      <DialogConfirmDelete
        isOpen={isOpenDialogConfirmDelete}
        loading={loadingDelete}
        onClose={onCloseDialogConfirmDelete}
        onConfirm={onDelete}
      />
    </OperationProvider>
  );
};
